<template>
    <div v-on:click="addFav(match)">
        <i class="fa fa-star-o" v-show="!isFavorite"></i>
        <i class="fa fa-star" v-show="isFavorite"></i>
    </div>
</template>

<script>
    import favorite from '@/mixins/favorite.js';
    export default {
        name: 'favButton',
        mixins: [favorite],
        props: ['match'],
        data () {
            return {
                selected: true
            }
        },
        mounted () {
            this.checkIsFavorite(this.match);

            this.$bus.$on('addFav', ($event) => {

                this.checkIsFavorite(this.match);

            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/favButton.vue